import * as React from 'react';
import * as Toast from '@radix-ui/react-toast';
import { X } from 'lucide-react'; // 使用 lucide-react 的 X 图标

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = React.useState([]);

  // 创建一个全局可访问的方法来显示toast
  React.useEffect(() => {
    window.showToast = (message, type = 'success') => {
      const id = Date.now();
      setToasts((prevToasts) => [...prevToasts, { id, message, type }]);
      
      // 自动移除
      setTimeout(() => {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
      }, 3000);
    };
    
    return () => {
      delete window.showToast;
    };
  }, []);

  return (
    <Toast.Provider swipeDirection="right">
      {children}
      {toasts.map((toast) => (
        <Toast.Root
          key={toast.id}
          className={`
            flex items-center justify-between bg-white rounded-md shadow-md p-3
            ${toast.type === 'success' ? 'border-l-4 border-green-500' : ''}
            ${toast.type === 'error' ? 'border-l-4 border-red-500' : ''}
          `}
          duration={3000}
        >
          <Toast.Title className="text-sm font-medium">{toast.message}</Toast.Title>
          <Toast.Close className="ml-4 text-gray-400 hover:text-gray-500">
            <X className="w-4 h-4" />
          </Toast.Close>
        </Toast.Root>
      ))}
      
      {/* 居中 + 从上至下排列 */}
      <Toast.Viewport className="fixed top-5 left-1/2 transform -translate-x-1/2 flex flex-col-reverse gap-2.5 z-[9999] max-w-sm" />
    </Toast.Provider>
  );
};